module.exports = __webpack_public_path__ + "static/media/SV.63b9df6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SV.svg
// module id = 366
// module chunks = 0